import React, { Component } from 'react';
import { MultiSelectFilter, SelectTypes } from 'common/components/core/select';
import { translate } from 'react-i18next';
import compose from 'recompose/compose';
import { FeedbackStatusType } from 'common/models/internal/IntelliSortRequest';

class FeedbackStatusFilter extends Component {
    constructor(props) {
        super(props);
        this.FeedbackStatusTypes = Object.entries(
            FeedbackStatusType.keyToValueMap
        ).map(FeedbackStatus => ({
            label: FeedbackStatus[0],
            value: FeedbackStatus[1]
        }));
    }

    onFeedbackStatusTypeClick = ({ values }) => {
        const { onChange } = this.props;
        const feedbackStatusTypesList = values.map(value => value.value);

        if (!feedbackStatusTypesList.length) {
            onChange();
            return;
        }
        onChange({ values: feedbackStatusTypesList });
    };

    render() {
        const { theme, className, value, ...rest } = this.props;
        return (
            <MultiSelectFilter
                {...rest}
                theme={theme}
                className={className}
                selectType={SelectTypes.Outline}
                options={this.FeedbackStatusTypes}
                selected
                allowEmptyOrNull={false}
                value={value?.values || []}
                onChange={this.onFeedbackStatusTypeClick}
                disableBlanksSelectOption
            />
        );
    }
}

export default compose(translate())(FeedbackStatusFilter);
